<script lang="ts">
  interface Props {
    size?: number;
    [key: string]: any;
  }

  let { size = 16, ...rest }: Props = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...rest}
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M12.53 7.78a.75.75 0 00-1.06-1.06L8.75 9.44V1.75a.75.75 0 00-1.5 0v7.69L4.53 6.72a.75.75 0 00-1.06 1.06l4 4a.75.75 0 001.06 0l4-4zM1.75 13.5a.75.75 0 000 1.5h12.5a.75.75 0 000-1.5H1.75z"
    fill="currentColor"
  />
</svg>
